export const FileService={
    base64FileToBlobUrl(base64File) {
        let blob = this.base64FileToBlob(base64File);
        return URL.createObjectURL(blob);
    },

    base64FileToBlob(base64File) {
        base64File = base64File.replace('data:application/pdf;base64,', '');
        base64File = base64File.replace('data:image/png;base64,', '');
        base64File = base64File.replace('data:image/jpeg;base64,', '');
        const byteCharacters = atob(base64File);
        const byteArrays = [];
        let sliceSize = 512;
        let contentType = 'application/pdf';
        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            const slice = byteCharacters.slice(offset, offset + sliceSize);

            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }
        return new Blob(byteArrays, {type: contentType});
    },
    /* eslint-disable */
    viewDocument(file,fileName) {
            const url = this.base64FileToBlobUrl(file);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('href', url);
            link.setAttribute('target', '_blank');
            document.body.appendChild(link);
            link.click();
    },

    getFileUrl(file){
        return this.base64FileToBlobUrl(file);
    },

    downloadDocument(fileData, fileName) {
        var fileURL = this.base64FileToBlobUrl(fileData);
        var fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', fileName);
        document.body.appendChild(fileLink);
        fileLink.click();
        fileLink.remove();
    },

    fileDownload(response, fileName) {
        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        var fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', fileName);
        document.body.appendChild(fileLink);
        fileLink.click();
        fileLink.remove();
    },

}